/**
 * cloudAlertsApi.js — API functions for the V2 Cloud Alerts page (5.0 platform).
 *
 * fetchCloudMaintenance — polls device maintenance (batteries, comm lost, other)
 *                          via `getdevicemaintenance` stored procedure (60s interval)
 */

import { apiFetch } from '../../../../services/api.js';

// ---------------------------------------------------------------------------
// Fetch Cloud Maintenance (batteries + communication lost + other)
// ---------------------------------------------------------------------------

/**
 * Calls `getdevicemaintenance` stored procedure.
 * Returns flat array of maintenance items with snake_case fields:
 *   { event_datetime_utc, condition, device_name, manufacture_uuid,
 *     manufacture_id, device_id, area_name, area_id, resident_name, resident_id }
 *
 * The caller splits by `condition` into batteries / lost / other buckets.
 *
 * @param {number} campusId — numeric campus ID
 * @returns {Promise<Array>}
 */
export function fetchCloudMaintenance(campusId) {
    return apiFetch({
        procedure: 'getdevicemaintenance',
        reqType: 'stored',
        pKey: 'campus_id',
        pVal: campusId,
        readOnly: true,
    });
}
